import React, { Component } from 'react';
import Trusted from '../common/Trusted';


export default class RefundPolicyBody extends Component {
  render() {
    return (
      <div>
                <div className="container-fluid term-condition">
        <h1 className="term-h1-heading">REFUND POLICY</h1>
          <div className="row">

            <section className="okjii-term-condition">
              <h2>RETURN POLICY</h2>
              <h3>Last updated March 20, 2020</h3>
              <p>Thank you for your purchase. We hope you are happy with your purchase. However, if you are not completely satisfied with your purchase for any reason, you may return it to us for store credit or an exchange. Please see below for more information on our return policy.</p>
              <h2>RETURNS</h2>
              <p>All returns must be postmarked within one (1) days of the purchase date. All returned items must be in new and unused condition, with all original tags and labels attached.</p>
              <h2>RETURN PROCESS</h2>
              <p>To return an item, place the item securely in its original packaging, our delivery executive will pick it from your prescribed address.</p>
              <p>There is no any return shipping charges. </p>
              <h2>REFUNDS</h2>
              <p>After receiving your return and inspecting the condition of your item, we will process your return or exchange. Please allow at least one (1) days from the receipt of your item to process your return or exchange. We will notify you by email when your return has been processed.</p>
              <h2>EXCEPTIONS </h2>
              <p>For defective or damaged products, please contact us at the customer service number below to arrange a refund or exchange. </p>
              <h3>Please Note</h3>
              <ul>
                <li>Orders can be canceled/exchange or return before it dispatched from shop only.   </li>
                <li>Orders placed mistakenly can be cancelled. </li>
                <li>Payment Will be reflect on wallets within 2 hours of return pick up.</li>
                <li>In case of damaged, mismatch, expired ,spoiler material, recommendations of our executive during the matching of order at the time of handling over the delivery will be the measure for exchange and return.</li>
                <li>Payment will not return to the original mode of payment, it will reflect on customer wallet only that can be redeemed for future order.</li>
                <li>If customer apply any offers on order and return that very order then the validity of offer will not remain applicable for dui order.</li>
                <li>If any customer deny to match order in front of our delivery person ,then the return of that order is not possible.</li>
                <li>Mismatching,leaks, packing default, damage , spoilded, damage, expiry are the parameters for return. </li>
                <li>We exchange the order instead of returning it completely. Exceptions are also there that is the autonomy of company.</li>
              </ul>
              <h2>QUESTIONS</h2>
              <p>If you have any questions concerning our return policy, please contact us at:<br />896913049 <br />support@okkji.com </p>
              
            </section>
            <Trusted />
            </div>
            </div>
      </div>
    )
  }
}
